module.exports = __webpack_public_path__ + "static/site-image-1200x630-f1f486a62e4905111d1b78558ef08eb3.png";